import { useSelector } from "react-redux";
import type { StoreWithTable } from "@fas/cpa-state-manager/services/selectors";
import { getTableData } from "@fas/cpa-state-manager/services/selectors";
import type { StoreWithLoading } from "@fas/cpa-state-manager/services/selectors/loading";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";

export type UseTableNoDataHook = {
  data: any[];
  isLoading: boolean;
  isFetched?: boolean;
};
export const useTableNoData = ({
  tableKey,
}: {
  tableKey: string;
}): UseTableNoDataHook => {
  const data = useSelector((state: StoreWithTable): any =>
    getTableData(state, tableKey)
  );
  const isLoading = useSelector((state: StoreWithLoading) =>
    getLoadingState(state, tableKey)
  );
  const isFetched = useSelector((state: StoreWithLoading) =>
    getLoadingState(state, `${tableKey}-fetched`)
  );
  return {
    data,
    isLoading,
    isFetched,
  };
};
